export default __webpack_public_path__ + "static/media/SNUG_DB_Grape.eb0f77d7.png";